import React from "react";
import { FormControl, TextField } from "@mui/material";

const RenderTextField = ({
  inputProps,
  input,
  classes,
  type,
  formControlClass,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <FormControl className={formControlClass}>
    <TextField
      data-testid="t-compone--RenderT-TextField"
      autoComplete="off"
      type={type}
      error={touched && invalid}
      helperText={touched && error}
      {...inputProps}
      {...custom}
      {...input}
    />
  </FormControl>
);

export default RenderTextField;
